import React from "react"
import { ICategory } from "../../contentful-types"
import { H2Library, FlexContainer } from "@carrotfertility/carotene"
import { ContentfulConditionalGate } from "../../lib/contentful/components/ContentfulConditionGate"
import { SubcategorySection } from "./SubcategorySection"
import { SubCategoryLink } from "./shared/ReadLearnLinks"

function SubCategoryNavigation({ subCategories, category }): JSX.Element {
  return (
    <FlexContainer height={"auto"} wrap={"wrap"} direction="row" gap="8px 0px" padding={"16px 0px 48px 0px"}>
      {subCategories.map((subCategory) => (
        <ContentfulConditionalGate conditions={subCategory.fields.conditions} key={subCategory.fields.title}>
          <SubCategoryLink subCategory={subCategory} category={category} linkType={"text"} />
        </ContentfulConditionalGate>
      ))}
    </FlexContainer>
  )
}

type CategoryPageContentProps = {
  category: ICategory
}

export function CategoryPageContent({ category }: CategoryPageContentProps): JSX.Element {
  const { subCategories } = category.fields
  return (
    <>
      <H2Library> {category.fields.title} </H2Library>
      <SubCategoryNavigation {...{ category, subCategories }} />
      {subCategories.map((subCategory, i, subCategories) => (
        <ContentfulConditionalGate key={subCategory.fields.title} conditions={subCategory.fields.conditions}>
          <SubcategorySection subCategory={subCategory} category={category} isLast={i + 1 === subCategories.length} />
        </ContentfulConditionalGate>
      ))}
    </>
  )
}
